import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAuthenticated, isAdmin } from '../store/action/auth';

const AdminRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={ props =>
      isAuthenticated() && isAdmin() ? (
        <Component {...props} />
      ) :
      (
        <Redirect
          to={{
            pathname: '/admin',
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

export default AdminRoute;
